(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/user-provider.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/user-provider.js');
"use strict";


const {
  createContext,
  useState,
  useContext,
  useCallback,
  useEffect
} = React;
const {
  CHANGE_PASSWORD
} = svs.ticket_partner.constants.routes;
const UserContext = createContext();
svs.ticket_partner.UserContext = UserContext;
const useUser = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER_CORP));
  const [oneTimePassword, setOneTimePassword] = svs.ticket_partner.sharedComponents.hooks.useLocalStorage('B2B_ONE_TIME_PASSWORD', false);
  const {
    status,
    result,
    error,
    run
  } = svs.ticket_partner.sharedComponents.hooks.useTask();
  const {
    redirectToKeepReturnUrlOrBack,
    redirectToStartPage
  } = svs.ticket_partner.sharedComponents.hooks.useReturnUrl();
  const companyDetailsPromise = svs.ticket_partner.sharedComponents.hooks.usePromiseDeferred();

  useEffect(async () => {
    if (isLoggedIn) {
      try {
        const {
          response
        } = await svs.ticket_partner.services.getCompanyDetails();
        companyDetailsPromise.resolve({
          companyDetails: response === null || response === void 0 ? void 0 : response.companyCustomer
        });
      } catch (e) {
        companyDetailsPromise.resolve({
          companyDetails: null
        });
        svs.ticket_partner.logger.error('failed to fetch company details', e);
      }
    }
  }, [companyDetailsPromise, isLoggedIn]);
  const login = useCallback(async (email, password) => {
    try {
      await run(svs.ticket_partner.utils.login(email, password));
    } catch (e) {}
  }, [run]);
  const logout = useCallback(() => {
    svs.ui.loader.show();
    svs.core.userSession.logout();
    redirectToStartPage();
  }, []);
  useEffect(() => {
    if (status === 'resolved') {
      var _result$response, _result$response2;
      const redirect = Boolean((_result$response = result.response) === null || _result$response === void 0 || (_result$response = _result$response.userNotifications) === null || _result$response === void 0 ? void 0 : _result$response.REDIRECT);
      const loggedIn = ((_result$response2 = result.response) === null || _result$response2 === void 0 || (_result$response2 = _result$response2.session) === null || _result$response2 === void 0 ? void 0 : _result$response2.role) === svs.core.userSession.roles.RETAILER_CORP;
      setOneTimePassword(redirect);
      setIsLoggedIn(loggedIn);
      if (redirect) {
        redirectToKeepReturnUrlOrBack(CHANGE_PASSWORD);
      }
    } else if (status === 'rejected') {
      svs.ticket_partner.utils.showErrorDialog(svs.ticket_partner.utils.loginErrorMapper(error));
    }
  }, [status, result, error, setOneTimePassword]);
  return {
    isLoggedIn: isLoggedIn && !oneTimePassword,
    hasRetailerCorpRole: isLoggedIn,
    login,
    logout,
    hasOneTimePassword: oneTimePassword && isLoggedIn,
    setOneTimePasswordUpdated: () => setOneTimePassword(false),
    companyDetailsPromise: companyDetailsPromise.promise
  };
};
const UserProvider = _ref => {
  let {
    children
  } = _ref;
  const user = useUser();
  return React.createElement(UserContext.Provider, {
    value: user
  }, children);
};
function useUserContext() {
  return useContext(UserContext);
}
svs.ticket_partner.useUserContext = useUserContext;
svs.ticket_partner.UserProvider = UserProvider;

 })(window);